// Review carousel: arrows, dots and optional autoplay over a scroll-snap track (swipe is native).
// Autoplay stops while the pointer or focus is on the block, in a hidden tab, in the editor and for visitors
// who ask for reduced motion.
(function () {
  if (customElements.get('review-carousel')) return;

  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.dots = this.querySelector('[data-dots]');
      this.loop = this.dataset.loop === 'true';
      if (!this.track) return;

      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateState());
      };
      this.onResize = () => this.setup();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index() - 1));
      if (this.next) this.next.addEventListener('click', () => this.goTo(this.index() + 1));

      this.setup();
      this.startAutoplay();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      window.removeEventListener('resize', this.onResize);
    }

    step() {
      var slides = this.track.children;
      if (slides.length < 2) return this.track.clientWidth || 1;
      return slides[1].offsetLeft - slides[0].offsetLeft || 1;
    }

    lastIndex() {
      var perView = Math.max(1, Math.round((this.track.clientWidth + this.gap()) / this.step()));
      return Math.max(0, this.track.children.length - perView);
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap) || 0;
    }

    index() {
      return Math.round(this.track.scrollLeft / this.step());
    }

    goTo(target) {
      var last = this.lastIndex();
      var next = target;
      if (next > last) next = this.loop ? 0 : last;
      if (next < 0) next = this.loop ? last : 0;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: next * this.step(), behavior: smooth ? 'smooth' : 'auto' });
    }

    setup() {
      var last = this.lastIndex();
      var hasMore = last > 0;
      if (this.prev) this.prev.hidden = !hasMore;
      if (this.next) this.next.hidden = !hasMore;
      if (this.dots) {
        this.dots.hidden = !hasMore;
        this.dots.textContent = '';
        for (var i = 0; hasMore && i <= last; i++) this.dots.appendChild(this.createDot(i));
      }
      this.updateState();
    }

    createDot(i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'review-carousel__dot';
      dot.setAttribute('aria-label', (this.dataset.goToLabel || '').replace('__N__', i + 1));
      dot.addEventListener('click', () => this.goTo(i));
      return dot;
    }

    updateState() {
      var current = this.index();
      var last = this.lastIndex();
      if (this.prev) this.prev.disabled = !this.loop && current <= 0;
      if (this.next) this.next.disabled = !this.loop && current >= last;
      if (!this.dots) return;
      Array.prototype.forEach.call(this.dots.children, function (dot, i) {
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    startAutoplay() {
      if (this.dataset.autoplay !== 'true') return;
      if (window.Shopify && Shopify.designMode) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var seconds = parseInt(this.dataset.autoplaySeconds, 10) || 5;
      this.timer = setInterval(() => {
        if (document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
        this.goTo(this.index() + 1);
      }, seconds * 1000);
    }
  }

  customElements.define('review-carousel', ReviewCarousel);
})();
